@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}
<form #form="ngForm" (keydown.enter)="$event.preventDefault()" novalidate>
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion">
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <span class="mat-content"><mat-panel-title class="mat-expansion-panel-header-title"><span class="index">1</span>{{'pages.organizations.organization.component.name-typology-organization'| translate}} </mat-panel-title></span>
          </mat-expansion-panel-header>
          <mat-card class="box mt-3">
            <div class="row">
              <mat-form-field class="col-12 col-md-4" appearance="fill">
                <mat-label>{{'pages.responses.responses-proposal-review.component.organization-name'| translate}}</mat-label>
                <input matInput [(ngModel)]="organizationInfo.name" required name="organization" type="text">
              </mat-form-field>
              <mat-form-field class="col-12 col-md-4" appearance="fill">
                <mat-label>{{'generic.typology'| translate}}</mat-label>
                <mat-select name="typology_organization" [(ngModel)]="organizationInfo.typology" required class="color-default">
                  @for (typology of getTypologiesService().getAllTypologiesForSelect(); track typology) {
                    <mat-option [value]="typology.key">{{typology.value}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion">
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <span class="mat-content"><mat-panel-title class="mat-expansion-panel-header-title"><span class="index">2</span>{{'generic.sector' | translate}} </mat-panel-title></span>
          </mat-expansion-panel-header>
          <div class="row">
            @for (sector of sectors; track sector; let i = $index) {
              <div class="col-12 col-lg-3 col-md-6">
                @if (i < currentNumOfSectorsShowed) {
                  <ng-container class="container box-logo">
                    <div class="mat-elevation-z8 box-sections" (click)="clickEvent(sector)" [ngClass]="sector.selected === true ? 'card-selected' : '' " >
                      <mat-label class="text-center">
                        <h2>{{sector.value}}</h2>
                        <mat-icon class="icon">{{sector.icon}}</mat-icon>
                      </mat-label>
                    </div>
                  </ng-container>
                }
              </div>
            }
          </div>
          @if (sectors.length > currentNumOfSectorsShowed) {
            <div class="d-flex justify-content-end my-5">
              <button mat-button class="d-flex align-items-end" (click)="onClickShowMore()">{{'generic.show-more'| translate}} <mat-icon>keyboard_arrow_down</mat-icon></button>
            </div>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="container-fluid accordion-container">
    <div class="container">
      <mat-accordion class="accordion">
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header class="mb-4">
            <span class="mat-content"><mat-panel-title class="mat-expansion-panel-header-title"><span class="index">3</span>{{'pages.organizations.organization.component.img-organization'| translate}}  </mat-panel-title></span>
          </mat-expansion-panel-header>
          <div class="mat-elevation-z8 box-custom-img">
            @if (!organizationInfo.logo_link) {
              <img class="organization-logo" src="assets/img/placeholder-img-organization.jpg" alt="">
            }
            @if (organizationInfo.logo_link) {
              <img class="organization-logo" [src]="organizationInfo.logo_link" alt="">
            }
            <button mat-button color="primary" class="mt-2 px-5" (click)="onClickUploadLogo()">{{'pages.organizations.organization.component.upload-logo'| translate}}  &nbsp;<i class="icon-upload"></i></button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div class="buttons-container container py-4">
    @if (!organizationInfo.id) {
      <button type="button" class="button-primary float-left" mat-button backbutton>
        <i class="icon-Backward-arrow-small"></i>
        {{'generic.buttons.back' | translate}}
      </button>
    }
    @if (organizationInfo.id) {
      <button type="button" class="button-primary float-left" mat-button [routerLink]="['../']" routerLinkActive="router-link-active">
        <i class="icon-Backward-arrow-small"></i>
        {{'generic.buttons.back' | translate}}
      </button>
    }
    <button type="button" class="button-primary float-right" [disabled]="loading" mat-button (click)="onSubmit(form)">
      <i class="icon-Forward-arrow-small"></i>
      @if (organizationInfo.id) {
        <span>{{'generic.buttons.update' | translate}}</span>
      }
      @if (!organizationInfo.id) {
        <span>{{'generic.buttons.save' | translate}}</span>
      }
    </button>
  </div>
</form>
